import { render, staticRenderFns } from "./AllTenants.vue?vue&type=template&id=7840c2ae&scoped=true&"
import script from "./AllTenants.vue?vue&type=script&lang=js&"
export * from "./AllTenants.vue?vue&type=script&lang=js&"
import style0 from "./AllTenants.vue?vue&type=style&index=0&id=7840c2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840c2ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7840c2ae')) {
      api.createRecord('7840c2ae', component.options)
    } else {
      api.reload('7840c2ae', component.options)
    }
    module.hot.accept("./AllTenants.vue?vue&type=template&id=7840c2ae&scoped=true&", function () {
      api.rerender('7840c2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/tenants/AllTenants.vue"
export default component.exports